import ButterflySubfamily from "./ButterflySubfamily";

class ButterflyFamily {
    public commonName: string;
    public scientificName: string;
    public subfamilyList: Array<ButterflySubfamily>

    constructor(commonName: string, scientificname: string) {
        this.commonName = commonName;
        this.scientificName = scientificname;
        this.subfamilyList = [];
    }
}

export default ButterflyFamily;